'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = contentReactionDetails;

var _actionTypes = require('../../actions/action-types');

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function users() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  var action = arguments[1];

  switch (action.type) {
    case _actionTypes.RECEIVE_REACTION_USERS:
      var nextUsers = action.payload.users;

      return [].concat(_toConsumableArray(state), _toConsumableArray(nextUsers));
    default:
      return state;
  }
}

function reaction() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    isError: false,
    isFetching: false,
    isFinished: false,
    nextReactionDate: null,
    users: []
  };
  var action = arguments[1];

  switch (action.type) {
    case _actionTypes.REQUEST_REACTION_USERS:
      return Object.assign({}, state, {
        isFetching: true
      });
    case _actionTypes.FAIL_RECEIVE_REACTION_USERS:
      return Object.assign({}, state, {
        isError: true,
        isFetching: false
      });
    case _actionTypes.RECEIVE_REACTION_USERS:
      var firstReactionDate = action.payload.firstReactionDate;

      return Object.assign({}, state, {
        isFetching: false,
        nextReactionDate: firstReactionDate,
        users: users(state.users, action)
      });
    case _actionTypes.FINISHED_REACTION_USERS:
      return Object.assign({}, state, {
        isFinished: true
      });
    default:
      return state;
  }
}

function reactionDetails() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _actionTypes.REQUEST_REACTION_USERS:
    case _actionTypes.FAIL_RECEIVE_REACTION_USERS:
    case _actionTypes.RECEIVE_REACTION_USERS:
    case _actionTypes.FINISHED_REACTION_USERS:
      var reactionType = action.payload.reaction;

      return Object.assign({}, state, _defineProperty({}, reactionType, reaction(state[reactionType], action)));
    default:
      return state;
  }
}

function contentReactionDetails() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  switch (action.type) {
    case _actionTypes.REQUEST_REACTION_USERS:
    case _actionTypes.FAIL_RECEIVE_REACTION_USERS:
    case _actionTypes.RECEIVE_REACTION_USERS:
    case _actionTypes.FINISHED_REACTION_USERS:
      var _action$payload = action.payload,
          communityContentType = _action$payload.communityContentType,
          communityContentRelatedId = _action$payload.communityContentRelatedId;

      var communityContentIdKey = communityContentType + '-' + communityContentRelatedId;

      var _ref = state[communityContentIdKey] || {},
          previousReactionDetails = _ref.reactionDetails;

      return Object.assign({}, state, _defineProperty({}, communityContentIdKey, {
        reactionDetails: reactionDetails(previousReactionDetails, action)
      }));
    default:
      return state;
  }
}